<template>
<div id=app>
  <router-view />
</div>
</template>

<style lang="scss">
  $font_path: './assets/fonts/';

  @font-face{
    font-family: 'Sukhumvit-Light';
    src: url($font_path + 'SukhumvitSet-Light.ttf');
    src: url($font_path + 'SukhumvitSet-Light.ttf') format('truetype');
    font-style: normal;
    font-weight: 300;
  }

  @font-face{
    font-family: 'Sukhumvit';
    src: url($font_path + 'SukhumvitSet-Text.ttf');
    src: url($font_path + 'SukhumvitSet-Text.ttf') format('truetype');
    font-style: normal;
    font-weight: 400;
  }

  @font-face{
    font-family: 'Sukhumvit-Medium';
    src: url($font_path + 'SukhumvitSet-Medium.ttf');
    src: url($font_path + 'SukhumvitSet-Medium.ttf') format('truetype');
    font-style: normal;
    font-weight: 500;
  }

  @font-face{
    font-family: 'Sukhumvit-SemiBold';
    src: url($font_path + 'SukhumvitSet-SemiBold.ttf');
    src: url($font_path + 'SukhumvitSet-SemiBold.ttf') format('truetype');
    font-style: normal;
    font-weight: 600;
  }

  @font-face{
    font-family: 'Sukhumvit-Bold';
    src: url($font_path + 'SukhumvitSet-Bold.ttf');
    src: url($font_path + 'SukhumvitSet-Bold.ttf') format('truetype');
    font-style: normal;
    font-weight: 900;
  }

  body {
    font-family: 'Sukhumvit', Helvetica, sans-serif;
    font-weight: 400;
    font-style: normal;
    min-height: 100%;
    height: auto;
  }

  h2 {
    font-family: 'Sukhumvit';
  }
</style>

<script>
export default {
  name: 'App',
}
</script>
